module.exports = __webpack_public_path__ + "static/media/02.2f653ac2.png";